(function ($) {
    $(function () {
        if ($('.team-member-block').length < 1) {
            return;
        }

        // Variables
        var accordions = $('.team-member-block .team-member');
        var closedClass = 'team-member--closed';
        var openClass = 'team-member--open';

        // ------------------------------------------------------------- //

        /**
         * Accordion functionality.
         * 
         * Close all accordion blocks on page load.
         */
        accordions.addClass(closedClass);

        // Begin functionality
        accordions.each(function () {

            var accordion = $(this);
            var toggle = $(this).find('.content__toggle');
            var toggleHiddenClass = ('content__toggle--hidden');
            var toggleIcon = toggle.find('.icon');
            var toggleText = toggle.find('.text');
            var excerptContainer = $(this).find('.content__body');
            var excerpt = excerptContainer.find('p').first();

            toggle.removeClass(toggleHiddenClass);

            toggle.click(function (e) {
                // Prevent default anchor action
                e.preventDefault();

                // Close all other open accordions first
                accordions.not(accordion).addClass(closedClass);
                accordions.not(accordion).find('.content__body p:not(:first-of-type)').slideUp();
                accordions.not(accordion).find('.content__toggle .close').addClass('hidden');
                accordions.not(accordion).find('.content__toggle .open').removeClass('hidden');

                // Open current accordion
                excerptContainer.find('p').not(excerpt).slideToggle();
                accordion.toggleClass(closedClass);
                toggleIcon.find('.svg-container').toggleClass('svg-container--hidden');

                /**
                 * Change toggle link text
                 */
                if ($(this).closest(accordion).hasClass(closedClass)) {
                    toggleText.text(toggleText.text().replace('Hide', 'Read'));

                } else {
                    // If the accordion is open then replace "Read..." with "Hide..."
                    toggleText.text(toggleText.text().replace('Read', 'Hide'));

                    // Set all other toggle buttons to their original state
                    $('.content__toggle .text').not(toggleText).each(function () {

                        // Only if the text has the word "Hide" in it
                        if ($(this).text().indexOf('Hide') != -1) {

                            // Replace "Hide" with "Read..."
                            $(this).text($(this).text().replace('Hide', 'Read'));
                        }
                    });

                    // Set all other toggle button icons to their original state
                    $('.content__toggle .icon').not(toggleIcon).find('.svg-container').each(function () {
                        if ($(this).hasClass('svg-container--open')) {
                            $(this).removeClass('svg-container--hidden');
                        } else if ($(this).hasClass('svg-container--close')) {
                            $(this).addClass('svg-container--hidden');
                        }
                    });
                }
            });

        });
    });
})(jQuery);